// extracted by mini-css-extract-plugin
export default {"cta":"eI-z","disabled":"fI-z"};